function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(1 -2.979)"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#FFF",
  strokeLinecap: "square",
  d: "M195 185.979l-14-168 14 168z",
  opacity: 0.246
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#FFF",
  strokeLinecap: "square",
  opacity: 0.248,
  d: "M182 19.979l96 85"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#FFF",
  strokeLinecap: "square",
  d: "M424 57.979l-122 52m-260 30l232-23"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#FFF",
  strokeLinecap: "square",
  opacity: 0.25,
  d: "M316 312.979l-27-183"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#FFF",
  opacity: 0.248,
  d: "M425 164.979l-123-43"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 288.578,
  cy: 115.211,
  fill: "#23C386",
  rx: 8.039,
  ry: 8.038,
  transform: "rotate(40 288.578 115.211)"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 288.578,
  cy: 115.211,
  stroke: "#FFF",
  rx: 14.292,
  ry: 14.29,
  transform: "rotate(40 288.578 115.211)"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 195.187,
  cy: 186.425,
  fill: "#23C386",
  rx: 18.759,
  ry: 18.755,
  transform: "rotate(40 195.187 186.425)"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 448.886,
  cy: 46.683,
  fill: "#23C386",
  rx: 18.079,
  ry: 18.08,
  transform: "rotate(40 448.886 46.683)"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#FFF",
  d: "M431.645 67.662c11.423 9.584 28.453 8.095 38.038-3.328 9.585-11.423 8.095-28.453-3.328-38.038-11.423-9.585-28.453-8.095-38.038 3.328-9.585 11.423-8.095 28.453 3.328 38.038z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 22,
  cy: 140.979,
  r: 15,
  fill: "#1F78B4"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 21,
  cy: 141.979,
  r: 21,
  stroke: "#FFF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 315.5,
  cy: 312.479,
  r: 14.5,
  fill: "#2C439C"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 425.816,
  cy: 164.803,
  fill: "#7A3390",
  rx: 8.043,
  ry: 8.034,
  transform: "rotate(10 425.816 164.803)"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 181.101,
  cy: 17.297,
  fill: "#7A3390",
  rx: 14.298,
  ry: 14.283,
  transform: "rotate(10 181.101 17.297)"
}));

function SvgWhoFindsOut(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 478 324"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,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";
export { SvgWhoFindsOut as ReactComponent };